import { render, staticRenderFns } from "./AssignActionFooter.vue?vue&type=template&id=3e9ba438&"
import script from "./AssignActionFooter.vue?vue&type=script&lang=js&"
export * from "./AssignActionFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports